module.exports = __webpack_public_path__ + "media/assets/images/blog/headphones-customer-service-e73282aaf4d0895acea7ed4c0148ef83.jpeg";